import { useState } from 'react';
import { useSelector } from 'react-redux';
import deepEquals from '../../../../Lib/Object/deepEquals';
import { Button, Checkbox, Field, Label, NumericInput, TextOutput } from '../../../Core';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../Layout';
import { WorksheetEquipmentDropdown } from '../../Core';
import { WorksheetBalanceFieldSet } from '../../Core/WorksheetEquipment';

let PreparationSection = ({ createWorksheetSelector }) => {
  const [testConditionsEditable, setTestConditionsEditable] = useState(false);

  const initiallyPreparedMassRecorded = useSelector(
    createWorksheetSelector('Preparation.InitiallyPreparedMassRecorded')
  );
  const aggregateSoaked = useSelector(createWorksheetSelector('Preparation.AggregateSoaked'));
  const aggregateOvenDriedPriorToSoaking = useSelector(
    createWorksheetSelector('Preparation.AggregateOvenDriedPriorToSoaking')
  );
  const thermometerId = useSelector(createWorksheetSelector('Equipment.Thermometer.Id'));
  const thermometerCalibrationMismatch = useSelector(
    createWorksheetSelector('Equipment.ThermometerCalibrationMismatch')
  );
  const thermometerReadings = useSelector(createWorksheetSelector('Equipment.ThermometerReadings'), deepEquals);

  return (
    <>
      <ListFieldSection visible={testConditionsEditable}>
        <Field
          emph
          input={<Checkbox />}
          label="Initially Prepared Mass Recorded"
          name="Preparation.InitiallyPreparedMassRecorded"
        />
        <Field emph input={<Checkbox />} label="Aggregate Soaked" name="Preparation.AggregateSoaked" />
        <Field
          emph
          input={<Checkbox />}
          label="Aggregate Oven Dried Prior to Soaking"
          name="Preparation.AggregateOvenDriedPriorToSoaking"
          visible={!!aggregateSoaked}
        />
        <Field
          emph
          input={<NumericInput />}
          label="Soaking Period"
          name="Preparation.SoakingPeriod"
          visible={!!aggregateSoaked}
        />
      </ListFieldSection>
      <ListFieldSection visible={!testConditionsEditable}>
        <Label emph>{`Initially Prepared Mass ${initiallyPreparedMassRecorded ? '' : 'Not '}Recorded`}</Label>
        <Label emph>{`Aggregate ${aggregateSoaked ? '' : 'Not '}Soaked`}</Label>
        <Label emph visible={!!aggregateSoaked}>
          {`Aggregate Oven Dried ${aggregateOvenDriedPriorToSoaking ? 'Prior to ' : 'After '}Soaking`}
        </Label>
        <Field
          emph
          input={<TextOutput />}
          label="Soaking Period"
          name="Preparation.SoakingPeriod"
          visible={!!aggregateSoaked}
        />
        <div>
          <Button
            onClick={() => {
              setTestConditionsEditable(true);
            }}
          >
            Change
          </Button>
        </div>
      </ListFieldSection>
      <ListFieldSection>
        <WorksheetBalanceFieldSet emph label="Balance" name="Equipment.Balance" />
        <Field emph input={<WorksheetEquipmentDropdown />} label="Oven" equipmentType="oven" name="Equipment.Oven" />
        <Field
          emph
          input={<WorksheetEquipmentDropdown />}
          label="Thermometer"
          equipmentType="thermometer"
          name="Equipment.Thermometer"
          importModel={{ Id: thermometerId }}
          importedCalibration={{
            Readings: thermometerReadings,
            Mismatch: thermometerCalibrationMismatch,
          }}
        />
      </ListFieldSection>
    </>
  );
};

PreparationSection = withInjectedProps(PreparationSection);

export { PreparationSection };
export default PreparationSection;
